export default {
	1: { name: "mainnet", contractAddress: "0xD3321D33F55b71BD4463B3584aDbACcE13b8e17F" },
	4: { name: "rinkeby", contractAddress: "0x39270eAc16FCb7aF3Fd0c8C04ae6Bc5f899BdB80" },
}
